import React, {memo, useEffect, useState} from "react";
import Container from "@mui/material/Container";
import {connect, useDispatch, useSelector} from "react-redux";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import Api from "../../utils/api";
import {Head, Loading} from "../../components";
import {Box} from "@mui/material";
import ReactPaginate from "react-paginate";
import Button from "@mui/material/Button";
import {Link, useNavigate} from "react-router-dom";





const Comments = () => {


    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const history = useNavigate()


    useEffect(() => {
        handleList()
    }, [])


    const handleList = () => {
        setLoading(true)
        let obj = {
            "form": "product_comment_get_admin",
            "product_id": null,
            "status": null,
            "user_id": null
        }
        new Api().get('/products/comments/list', obj).then((response) => {
            if (typeof response !== "undefined") {
                setData(response);
            }

            setLoading(false);
        })
    }


    const pageCount = Math.ceil(parseInt(data?.total) / parseInt(data?.per_page));

    return (
        <Container>

            <div>
                <Head data={{'link': '/discount', 'title': 'نظرات کاربران'}}/>

                <Box>
                    <>
                        <div style={{overflowX: 'auto'}}>
                            <table className='table'>
                                <thead>
                                <tr>
                                    <th>ردیف</th>
                                    <th>عنوان</th>
                                    <th>امتیاز</th>
                                    <th>نظر جدید</th>
                                    <th>مشاهده نظرات</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    data?.details?.data?.map((item, index) => {

                                        return (
                                            <>
                                                <tr>
                                                    <td>{index + 1}</td>
                                                    <td>{item.title}</td>
                                                    <td>{item.score}</td>
                                                    <td>{item.new_comments_count}</td>
                                                    <td>
                                                       <Button  variant='contained' color='primary' onClick={() => history(`/product/updateOrCreate/${item.id}` ,8)}>
                                                            مشاهده
                                                       </Button>
                                                    </td>
                                                </tr>
                                            </>

                                        )
                                    })
                                }
                                </tbody>
                            </table>

                        </div>
                        {loading && <Loading/>}

                        <ReactPaginate
                            previousLabel={'<'}
                            nextLabel={'>'}
                            breakLabel={'...'}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={(selectedItem) => setPage(selectedItem.selected + 1)}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                        />
                    </>
                    {loading && <Loading/>}
                </Box>
            </div>

        </Container>
    );
}

const mapStateToProps = state => ({
    settingReducer: state.settingReducer,
    authReducer: state.authReducer
})

export default connect(mapStateToProps)(Comments);